module.exports = __webpack_public_path__ + "static/media/ilu2.f76712e6.png";